// Post Detail Styles
// Post detail/thread view styling

import styled from 'styled-components';
import { theme } from '../theme';
import { ChatRoomTheme } from '../../contexts/ChatRoomThemeContext';

export const PostDetailContainer = styled.div<{ $theme: ChatRoomTheme }>`
  background: ${props => props.$theme === 'dark' ? '#0a0a0a' : '#ffffff'};
  min-height: 100vh;
  width: 100%;
  padding: 0;
  padding-bottom: calc(80px + 60px);
  padding-top: 20px;
  color: ${props => props.$theme === 'dark' ? 'white' : '#333'};

  @media (max-width: ${theme.breakpoints.mobile}) {
    padding-bottom: calc(100px + 60px);
    padding-top: 20px;
  }
`;

export const PostDetailBackButton = styled.button<{ $theme: ChatRoomTheme }>`
  background: none;
  border: none;
  color: ${props => props.$theme === 'dark' ? 'white' : '#333'};
  font-size: 1rem;
  cursor: pointer;
  padding: 0.5rem 1rem;
  margin: 0 1.25rem 1rem 1.25rem;
  border-radius: 8px;
  transition: background 0.2s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  &:hover {
    background: ${props => props.$theme === 'dark' 
      ? 'rgba(255, 255, 255, 0.1)' 
      : 'rgba(0, 0, 0, 0.05)'};
  }

  @media (max-width: ${theme.breakpoints.mobile}) {
    margin: 0 1rem 0.75rem 1rem;
    padding: 0.5rem 0.75rem;
  }
`;

export const PostSection = styled.div`
  padding: 0 1.25rem;
  margin-bottom: 2rem;

  @media (max-width: ${theme.breakpoints.mobile}) {
    padding: 0 1rem;
    margin-bottom: 1.5rem;
  }
`;

export const CommentsSection = styled.div`
  padding: 0 1.25rem;
  padding-bottom: 1rem;

  @media (max-width: ${theme.breakpoints.mobile}) {
    padding: 0 1rem;
    padding-bottom: 1rem;
  }
`;

export const CommentsHeader = styled.div<{ $theme: ChatRoomTheme }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid ${props => props.$theme === 'dark' 
    ? 'rgba(255, 255, 255, 0.1)' 
    : 'rgba(0, 0, 0, 0.1)'};
`;

export const CommentsTitle = styled.h2<{ $theme: ChatRoomTheme }>`
  font-size: 1.125rem;
  font-weight: 600;
  color: ${props => props.$theme === 'dark' ? 'white' : '#333'};
  margin: 0;
`;

export const CommentsList = styled.div`
  margin-bottom: 2rem;
`;

export const AddCommentSection = styled.div<{ $theme: ChatRoomTheme }>`
  background: ${props => props.$theme === 'dark' 
    ? 'rgba(255, 255, 255, 0.05)' 
    : 'rgba(0, 0, 0, 0.02)'};
  border: 1px solid ${props => props.$theme === 'dark' 
    ? 'rgba(255, 255, 255, 0.1)' 
    : 'rgba(0, 0, 0, 0.1)'};
  border-radius: 12px;
  padding: 1rem;
  margin-top: 1.5rem;
`;

export const CommentInput = styled.textarea<{ $theme: ChatRoomTheme }>`
  width: 100%;
  min-height: 100px;
  background: ${props => props.$theme === 'dark' 
    ? 'rgba(255, 255, 255, 0.05)' 
    : 'rgba(0, 0, 0, 0.02)'};
  border: 1px solid ${props => props.$theme === 'dark' 
    ? 'rgba(255, 255, 255, 0.2)' 
    : 'rgba(0, 0, 0, 0.1)'};
  border-radius: 8px;
  padding: 0.75rem;
  color: ${props => props.$theme === 'dark' ? 'white' : '#333'};
  font-size: 0.9rem;
  font-family: inherit;
  resize: vertical;
  margin-bottom: 0.75rem;

  &::placeholder {
    color: ${props => props.$theme === 'dark' 
      ? 'rgba(255, 255, 255, 0.5)' 
      : 'rgba(0, 0, 0, 0.5)'};
  }

  &:focus {
    outline: none;
    border-color: ${theme.colors.primary};
    background: ${props => props.$theme === 'dark' 
      ? 'rgba(255, 255, 255, 0.08)' 
      : 'rgba(0, 0, 0, 0.04)'};
  }
`;

export const SubmitButton = styled.button<{ $disabled?: boolean }>`
  background: ${({ $disabled }) =>
    $disabled
      ? 'rgba(255, 255, 255, 0.1)'
      : 'linear-gradient(135deg, #ff8c42 0%, #ff6b9d 100%)'};
  color: white;
  border: none;
  border-radius: 8px;
  padding: 0.75rem 1.5rem;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  transition: all 0.2s ease;
  opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};

  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(255, 140, 66, 0.4);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }
`;

